module.exports = __webpack_public_path__ + "static/media/shape.c4b81e08.png";